import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Tile, TileCaption } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { DynamicHeroValues, useCMDynamicHero } from 'libs/dynamic-hero'
import { PrunedCourse } from 'libs/server/api'
import {
  MobileBackgroundImage,
  DesktopBackgroundImage,
} from './BackgroundImage'
import { ContentMobile, ContentDesktop } from './Content'
import { Data } from './types'
import classes from './Hero.module.scss'

export const Hero = () => {
  const { course, savedDynamicHero } = useStaticData<{
    course: PrunedCourse
    savedDynamicHero: DynamicHeroValues
  }>()

  const { header, subheader, nameplate } = useCMDynamicHero({
    useCourseDefaultValues: true,
  })

  const data: Data = {
    header,
    subheader,
    nameplate,
    isDynamicNameplate:
      !isEmpty(savedDynamicHero) &&
      savedDynamicHero?.nameplate !== course.nameplate,
  }

  return (
    <section className='mc-mb-10'>
      {/* Desktop and Tablet */}
      <div className='d-none d-md-flex'>
        <div className='col-6 mc-p-0' style={{ height: 700 }}>
          <Tile aspectRatio='auto'>
            <DesktopBackgroundImage />
          </Tile>
        </div>
        <div className={`col-6 mc-p-0 d-flex ${classes.heroContent}`}>
          <Tile aspectRatio='auto'>
            <TileCaption position='center center'>
              <ContentDesktop data={data} />
            </TileCaption>
          </Tile>
        </div>
      </div>

      {/* Mobile */}
      <div className='d-block d-md-none'>
        <MobileBackgroundImage />

        <div className={classes.contentContainer__mobile}>
          <ContentMobile data={data} />
        </div>
      </div>
    </section>
  )
}
